/*
 * IRIS Interactive
 *
 * NOTICE OF LICENSE
 *
 * This source file is no subject to a specific license
 * but it belongs to the company IRIS Interactive.
 * You can contact IRIS Interactive at the following
 * address: contact@iris-interactive.fr
 *
 * @author      Lucas ROCHE
 * @date        10/02/2020 08:34
 * @copyright   Copyright (c) 2002-2020 IRIS Interactive, Inc. (http://www.iris-interactive.fr)
 */

import Isotope from 'isotope-layout/dist/isotope.pkgd.min';
import imagesLoaded from 'imagesloaded/imagesloaded.pkgd.min';


export default class Gallery {
    
    constructor()
    {
        setTimeout(() => {
            this.initializeIsotope();
        }, 100);
    }
    
    initializeIsotope()
    {
        let grid     = document.querySelector( '[isotope-grid]' ),
            item     = '[isotope-item]',
            filters  = '[isotope-filters]',
            $filters = $( filters ),
            active   = 'current',
            gutterSize = 40;
        
        if ( window.matchMedia( "(max-width: 1000px)" ).matches ) {
            gutterSize   = 20;
        }
        
        if ( document.body.contains( grid ) ) {
            
            let iso = new Isotope( grid, {
                masonry: {
                    itemSelector: item,
                    gutter: gutterSize,
                }
            } );
            
            // Layout Isotope after each image loads
            let imgLoad = new imagesLoaded( iso );
            imgLoad.on( 'progress', function () {
                new Isotope( grid, 'layout' );
            } );
            
            if ( $filters.length > 0 ) {
                // Filter items on button click
                $filters.on( 'click', '.filterItem', function () {
                    let filterValue = $( this ).attr( 'data-filter' );
                    iso.arrange( { filter: filterValue } );
                } );
                
                // Change class on click
                $filters.each( function ( i, buttonGroup ) {
                    let $buttonGroup = $( buttonGroup );
                    $buttonGroup.on( 'click', '.filterItem', function () {
                        $buttonGroup.find( '.' + active ).removeClass( active );
                        $( this ).addClass( active );
                    } );
                } );
            }
        }
        
    }
}
